module.exports = __webpack_public_path__ + "img/services-icon-2.9b278850.png";